import React, { useMemo, useState } from "react";
import { Empty, Input } from "antd";

import DestinationCard from "./DestinationCard";
import { DESTINATION_TYPE } from "../constants";
import { TranslateText } from "@/utils/translation";

const t = (textKey) => <TranslateText textKey={textKey} namespace="pos" />;

const DestinationList = ({
  destinations,
  selectedDestination,
  onDestinationSelect,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDestinations = useMemo(() => {
    if (!searchTerm.trim()) return destinations;
    const search = searchTerm.toLowerCase();
    return destinations.filter((destination) => {
      const displayName =
        destination.type === DESTINATION_TYPE.TABLE
          ? destination.data?.name
          : destination.data?.roomNum;

      return displayName?.toLowerCase().includes(search);
    });
  }, [destinations, searchTerm]);

  const groupedDestinations = useMemo(() => {
    return {
      tables: filteredDestinations.filter(
        (item) => item.type === DESTINATION_TYPE.TABLE,
      ),
      rooms: filteredDestinations.filter(
        (item) => item.type === DESTINATION_TYPE.ROOM,
      ),
    };
  }, [filteredDestinations]);

  const hasData =
    groupedDestinations.tables.length || groupedDestinations.rooms.length;

  return (
    <div className="border rounded-lg overflow-hidden h-full">
      <div className="p-3 border-b">
        <Input
          allowClear
          placeholder="Search table/room"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="h-[430px] overflow-y-auto p-3">
        {!hasData ? (
          <Empty description={t("no_destination_found")} />
        ) : (
          <>
            {groupedDestinations.tables.length > 0 && (
              <>
                <h4 className="font-semibold mb-3 text-sm text-gray-600">
                  {t("tables")}
                </h4>

                <div className="space-y-2">
                  {groupedDestinations.tables.map((destination) => (
                    <DestinationCard
                      key={destination.id}
                      destination={destination}
                      selected={selectedDestination?.id === destination.id}
                      onSelect={onDestinationSelect}
                    />
                  ))}
                </div>
              </>
            )}

            {groupedDestinations.rooms.length > 0 && (
              <>
                <h4 className="font-semibold mt-6 mb-3 text-sm text-gray-600">
                  {t("rooms")}
                </h4>

                <div className="space-y-2">
                  {groupedDestinations.rooms.map((destination) => (
                    <DestinationCard
                      key={destination.id}
                      destination={destination}
                      selected={selectedDestination?.id === destination.id}
                      onSelect={onDestinationSelect}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DestinationList;
